import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import EngagementRateSlider from './EngagementRateSlider'
import NumberBox from './NumberBox'

export default observer(function EngagementRateFilter() {
  const { search } = useContext(SearchContext)
  const [minEngagementRate, setMinEngagementRate] = useState(search.min_engagement_rate)
  const timeout = useRef(null)

  useEffect(() => {
    setMinEngagementRate(search.min_engagement_rate)
  }, [search.min_engagement_rate])

  useEffect(() => () => clearTimeout(timeout.current), [])

  const update = value => {
    setMinEngagementRate(value)
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      search.order = 'engagement_rate'
      search.min_engagement_rate = String(value).replace(',', '.')
    }, 600)
  }

  return (
    <div className="flex flex-col gap-4">
      <EngagementRateSlider leftValue={0} rightValue={6} min={minEngagementRate} max={minEngagementRate} onInput={([, value]) => update(value)} />
      <div className="flex justify-end">
        <NumberBox label="Min" suffix="%" value={minEngagementRate} onChange={update} className="w-32" />
      </div>
    </div>
  )
})
